<template>
    <div v-loading="loading">
        <el-row >
            <slot name="search"></slot>
            <el-button @click="search()" type="primary" v-if="hasSearch">搜索</el-button>
            <slot name="searchButton"></slot>
        </el-row>
        <el-row class="basic-margin" style="margin-right:20pt;">
            <el-col :span="24">
                <div style="background-color: #eee;width: 100%;height: 100%;text-align: center;padding: 65px;"
                     v-if="datas.length==0 || loading">
                    {{loading?'加载中...':'暂时没有数据哦！'}}
                </div>
                <slot :datas="datas" name="item" v-else>

                </slot>
            </el-col>
        </el-row>

        <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[1,10, 20, 50, 100]"
                :total="totalCount"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                class="row basic-margin"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-left:0px">
        </el-pagination>
    </div>
</template>
<style scpoed>
    .top-margin {
        margin-left: 5px
    }
</style>

<script>
import Config from '../framework/configs/Config'
import BasicModel from '../framework/basic/BasicModel'
import BasicPager from '../mixins/BasicPager'

export default {
  name: 'list-template',
  extends: BasicPager,
  data: function () {
    return {
      loading: false,
      datas: [],
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false
    }
  },
  props: {
    actionUrl: {
      type: String,
      default: function () {
        return null
      }
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    hasSearch: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    handleSizeChange (val) { // 监听页数变化
      this.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) { // 监听页码变化
      this.currentPage = val
      this.loadList()
    },

    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this
      _this.loading = true
      _this.datas = []
      let loginInfo = _this.loginInfo
      let params = this.queryParams

      // 老的方法
      params.currentPage = _this.currentPage
      params.pageSize = _this.pageSize
      params.pageNo = _this.currentPage
      params.pageNum = _this.currentPage

      params.createType = loginInfo.loginPath === 'cxh' ? 1 : 2
      if (loginInfo.loginPath === 'channel') {
        params.channelId = loginInfo.loginPath === 'channel' ? loginInfo.id : null
      }
      let listener = {
        success: function (dataInfo) {
          _this.$emit('onDataFilter', dataInfo)

          for (var i = 0, temp = dataInfo.data.length; i < temp; i++) {
            let item = dataInfo.data[i]
            item.coverImgURL = Config.imageUrl + dataInfo.data[i].coverImgURL
          }

          _this.datas = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      BasicModel.get(this, this.actionUrl, params, listener)
    }
  }
}
</script>
